import { datadogLogs } from "@datadog/browser-logs";
import { v4 as uuidv4 } from "uuid";
import { SIFT_SDK_URL } from "@analytics/sift/constants";
import { retryOnFailure } from "src/utils/retryOnFailure";
import { loadScript } from "src/utils/scriptUtils";

const loadSiftSDK = () =>
  new Promise<void>((resolve, reject) => {
    loadScript({
      src: SIFT_SDK_URL,
      nodeId: "sift-sdk-script",
      isRemoveOnError: true,
      onLoad: resolve,
      onError: reject,
    });
  });

export class SiftWrapper {
  sessionId?: string;
  userId?: string;

  private getSessionId(): string {
    if (!this.sessionId) {
      this.sessionId = `session_${uuidv4()}_${Date.now()}`;
    }

    return this.sessionId;
  }

  init({ beaconKey, userId }: { beaconKey: string; userId?: string }) {
    retryOnFailure(loadSiftSDK)
      .then(() => {
        if (window._sift) {
          window._sift.push(["_setAccount", beaconKey]);
          window._sift.push(["_setSessionId", this.getSessionId()]);
          window._sift.push(["_trackPageview"]);

          this.setUserId(userId);
        } else {
          throw new Error("Sift SDK not found in window");
        }
      })
      .catch((error) => {
        datadogLogs.logger.warn(
          "Failed to initialize Sift",
          { userId, error },
          error
        );
      });
  }

  setUserId(userId?: string) {
    if (userId) {
      this.userId = userId;
    }

    if (this.userId) {
      window._sift?.push(["_setUserId", this.userId]);
    }
  }

  unsetUserId() {
    this.userId = undefined;

    window._sift?.push(["_unsetUserId"]);
  }
}

const siftWrapper = new SiftWrapper();

export default siftWrapper;
